import { render, staticRenderFns } from "./zbStudentList.vue?vue&type=template&id=7911b224"
import script from "./zbStudentList.vue?vue&type=script&lang=js"
export * from "./zbStudentList.vue?vue&type=script&lang=js"
import style0 from "./zbStudentList.vue?vue&type=style&index=0&id=7911b224&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports